export default __webpack_public_path__ + "static/media/gallery449_1.cd9d7e19.png";